import { Box, Icon, LargeIcon, Text, dimensions } from '@factorialco/deprecated-design-system'

interface EmptyStateProps {
  icon: LargeIcon
  textLine1: string
  textLine2?: string
}

export const EmptyState = ({ icon, textLine1, textLine2 }: EmptyStateProps) => {
  return (
    <Box
      textAlign="center"
      justifyContent="center"
      paddingBottom="s24"
      paddingTop="s32"
      style={{ transform: `translateY(-${dimensions.s24})` }}
      alignItems="center"
    >
      <Box paddingBottom="s8">
        <Icon.Large icon={icon} />
      </Box>

      <Text.Normal size="200">{textLine1}</Text.Normal>
      {textLine2 && <Text.Normal size="200">{textLine2}</Text.Normal>}
    </Box>
  )
}
